// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Tag, { TagPresentationProps } from "@insite/mobius/Tag";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import constants from "@store/constants";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/TrailerTracking/Handlers/UpdateSearchFields";
import updateTemporarySearchFields from "@store/Framework/Store/Greif/Pages/TrailerTracking/Handlers/UpdateTemporarySearchFields";
import { historyFilterProps } from "@store/Themes/common/props/history";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    getTrailersParameter: state.greif.pages.trailerTracking.getTrailersParameter,
});

const mapDispatchToProps = {
    updateSearchFields,
    updateTemporarySearchFields,
};

export interface OrderHistorySearchTagsStyles {
    appliedFiltersContainer?: InjectableCss;
    appliedFilterTag?: TagPresentationProps;
    tagWrapper?: TagWrapperProps;
}

export const trailerTrackingSearchTagsStyles: OrderHistorySearchTagsStyles = {
    tagWrapper: historyFilterProps.tagWrapper,
};

const styles = trailerTrackingSearchTagsStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const TrailerTrackingSearchTags = ({
    getTrailersParameter,
    updateSearchFields,
    updateTemporarySearchFields,
}: Props) => {
    const fieldRemoveHandler = (fieldName: string, value = "") => {
        updateSearchFields({ [fieldName]: !value ? undefined : value });
    };

    const tempFieldRemoveHandler = (fieldName: string, value = "") => {
        updateTemporarySearchFields({ [fieldName]: value });
    };

    return (
        <TagWrapper {...styles.tagWrapper}>
            {getTrailersParameter.trailerIdentification && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("trailerIdentification");
                    }}
                >
                    {`${translate("Trailer Id")}: ${getTrailersParameter.trailerIdentification}`}
                </Tag>
            )}
            {getTrailersParameter.shipToBp && getTrailersParameter.shipToBp !== "-1" && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("shipToBp", undefined);
                    }}
                >
                    {`${translate("Ship To")}: ${getTrailersParameter.shipToBp}`}
                </Tag>
            )}
            {getTrailersParameter.dwellTimeInDaysOperator && getTrailersParameter.dwellTimeInDays && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        tempFieldRemoveHandler("dwellTimeInDaysOperator");
                        tempFieldRemoveHandler("dwellTimeInDays");
                    }}
                    data-test-selector="trailerTrackingTags_DwellTime"
                >
                    {`${translate("Dwell Time (in Days)")}: ${getTrailersParameter.dwellTimeInDaysOperator} ${
                        getTrailersParameter.dwellTimeInDays
                    }`}
                </Tag>
            )}
            {getTrailersParameter.trailerGreifPlant && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("trailerGreifPlant");
                    }}
                >
                    {`${translate("Greif Plant")}: ${getTrailersParameter.trailerGreifPlant}`}
                </Tag>
            )}
            {getTrailersParameter.trailerCustomerOrder && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("trailerCustomerOrder");
                    }}
                >
                    {`${translate("PO #")}: ${getTrailersParameter.trailerCustomerOrder}`}
                </Tag>
            )}
            {getTrailersParameter.trailerItemDescription && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("trailerItemDescription");
                    }}
                >
                    {`${translate("Item Description")}: ${getTrailersParameter.trailerItemDescription}`}
                </Tag>
            )}
            {getTrailersParameter.trailerItem && (
                <Tag
                    {...styles.appliedFilterTag}
                    onDelete={() => {
                        fieldRemoveHandler("trailerItem");
                    }}
                >
                    {`${translate("Item Number")}: ${getTrailersParameter.trailerItem}`}
                </Tag>
            )}
        </TagWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TrailerTrackingSearchTags),
    definition: {
        group: constants.widgetGroup.trailerTracking,
        displayName: "Tags",
        allowedContexts: [constants.pageType.trailerTracking],
    },
};

export default widgetModule;
